import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'minDate',
    pure: false,
})
export class MinDatePipe implements PipeTransform {

    transform(...whatever: Date[]): Date | null {
        const valid = whatever.filter(d => !!d && !isNaN((new Date(d)).getTime()));
        if (valid.length === 0) {
            return null;
        }
        return valid.reduce((min, d) => d < min ? d : min);
    }

}
